import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../root/tcsm-model';
import { CompensationProps } from '../models/arc-epi-props';

export function useCompensationSetting() {

    const compensationSetting = useSelector<TcsmStates, CompensationProps>(state => state.epiProps?.compensationSettingsState?.epiContent);

    return compensationSetting;
}